module.exports = __webpack_public_path__ + "static/media/UrbanUs_featured.6b430240.jpeg";